import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../assets/img/general/tg.svg'


const _hoisted_1 = {
  key: 0,
  class: "p-3 flex bg-[#FFDBD766] flex-col items-center text-center rounded-lg border-[#FFB9B6] border-2"
}
const _hoisted_2 = {
  key: 1,
  class: "p-3 flex bg-[#FFDBD766] flex-col items-center text-center rounded-lg border-[#FFB9B6] border-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isTelegramConnect)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[2] || (_cache[2] = _createElementVNode("div", null, [
            _createTextVNode(" Звонки с кодом приходят не всегда. Подключите телеграм для получения кодов."),
            _createElementVNode("br"),
            _createElementVNode("strong", null, "Это безопасно!")
          ], -1)),
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openTelegram())),
            class: "mt-2 h-10 rounded-lg bg-[#FFD92F] px-6 flex items-center justify-center cursor-pointer"
          }, [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" Подключить ", -1),
            _createElementVNode("img", {
              src: _imports_0,
              alt: "telegram",
              class: "ml-2 w-6 h-6"
            }, null, -1)
          ]))])
        ]))
      : _createCommentVNode("", true),
    (_ctx.infoModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("div", null, "Вернитесь в начало и установите пароль через телеграм", -1)
        ]))]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_auto_animate]
  ])
}